var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "pdp-purchase-options", attrs: { role: "group" } },
    [
      _c("div", { staticClass: "pdp-purchase-container" }, [
        _c("div", { staticClass: "pdp-purchase-one-time" }, [
          _c("div", { staticClass: "pdp-purchase-option-main" }, [
            _c("h5", [_vm._v(_vm._s(_vm.translations.oneTime.title))]),
            _vm._v(" "),
            _vm.shopifyEnv != "myflavia"
              ? _c("span", [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.translations.oneTime.subTitle) +
                      "\n        "
                  )
                ])
              : _vm._e()
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "pdp-purchase-option-price" }, [
            _c("strong", [_vm._v(_vm._s(_vm.selectedVariant.formattedPrice))]),
            _vm._v(" "),
            _c("span", { staticClass: "pdp-purchase-option-price-compare" }, [
              _vm._v(
                "\n          " +
                  _vm._s(_vm.selectedVariant.formattedCompareAtPrice) +
                  "\n        "
              )
            ])
          ]),
          _vm._v(" "),
          _vm.variants && _vm.variants.length > 1
            ? _c(
                "div",
                { staticClass: "pdp-purchase-option-dropdown-select" },
                [
                  _c(
                    "select",
                    { on: { change: _vm.onChange } },
                    _vm._l(_vm.variants, function(variant) {
                      return _c(
                        "option",
                        {
                          key: variant.id,
                          domProps: {
                            value: variant.id,
                            selected: variant.id === _vm.selectedVariant.id
                          }
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(variant.title) +
                              "\n          "
                          )
                        ]
                      )
                    }),
                    0
                  ),
                  _vm._v(" "),
                  _c("svg", { staticClass: "icon icon-cheveron-down" }, [
                    _c("use", {
                      attrs: { "xlink:href": "#icon-cheveron-down" }
                    })
                  ])
                ]
              )
            : _vm._e()
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }